import i18n from 'translation/i18n';

const ScormWrapper = (() => {
    let api = null;
    let version = null;

    const isModeStandalone = process.env.REACT_APP_MODE_VAR === 'standalone';

    function decryptDate(enc) {
        return enc.split("").map(c => String.fromCharCode(c.charCodeAt(0) - 5)).join(""); // Simple decryption
    }

    function activityIsExpired(expirationCode) {
        if (!expirationCode) {
            return false; // No expiration
        }

        const expirationValue = decryptDate(expirationCode);
        const expirationDate = new Date(parseInt(expirationValue));

        return (new Date() > expirationDate);
    }

    function findAPI(targetWindow) {
        let tries = 0;
        const MAX_TRIES = 10;

        while (!targetWindow.API && !targetWindow.API_1484_11 && targetWindow.parent !== targetWindow && tries < MAX_TRIES) {
            tries++;
            targetWindow = targetWindow.parent;
        }

        if (targetWindow.API_1484_11) {
            console.log("SCORM 2004 API found");
            return targetWindow.API_1484_11;
        } else if (targetWindow.API) {
            console.log("SCORM 1.2 API found");
            return targetWindow.API;
        }

        return null;
    }

    function getAPI() {
        if (api) return api; // ✅ Always return the same instance

        api = findAPI(window);
        if (!api && window.opener) {
            api = findAPI(window.opener);
        }

        if (!api) {
            console.log("SCORM API not found!");
        }

        return api;
    }

    function init(expirationCode) {

        // TODO: This should be a global behavior and not SCORM specific
        if (activityIsExpired(expirationCode)) {
            document.body.innerHTML = i18n.t('accessibility.expiredScorm'); // Block the app by clearing content
            console.log("Access Denied");
            return;
        }

        if (!isModeStandalone) return;
        if (api) return; // ✅ Prevent multiple initializations

        api = getAPI();
        if (api) {
            if (api.Initialize) {
                version = "2004";
                api.Initialize("");
            } else if (api.LMSInitialize) {
                version = "1.2";
                api.LMSInitialize("");
            }
            console.log(`SCORM ${version} Initialized`);

            window.addEventListener("beforeunload", finish);
            window.addEventListener("pagehide", finish);
        } else {
            console.log("SCORM API not found");
        }
    }

    function setCompletionStatus(status) {
        if (!api) return;

        if (version === "2004") {
            api.SetValue("cmi.completion_status", status);
        } else {
            api.LMSSetValue("cmi.core.lesson_status", status);
        }

        console.log(`Completion status set to: ${status}`);

        if (status === "completed" && version === "2004") {
            setSuccessStatus("passed");
        } else if (version === "1.2") {
            console.warn("SCORM 1.2 does not support success status.");
        }

        commit();
    }

    function setSuccessStatus(status) {
        if (!api || version !== "2004") return;

        api.SetValue("cmi.success_status", status);
        console.log(`Success status set to: ${status}`);
        commit();
    }

    function setScore(score, maxScore = 100) {
        if (!api) return;

        if (version === "2004") {
            api.SetValue("cmi.score.raw", score.toString());
            api.SetValue("cmi.score.max", maxScore.toString());
        } else {
            api.LMSSetValue("cmi.core.score.raw", score.toString());
            api.LMSSetValue("cmi.core.score.max", maxScore.toString());
        }

        console.log(`Score set: ${score}/${maxScore}`);
        commit();
    }

    function commit() {
        if (!api) return;

        if (version === "2004") {
            api.Commit("");
        } else {
            api.LMSCommit("");
        }

        console.log("SCORM progress committed.");
    }

    function finish() {
        if (!api) return;

        if (version === "2004") {
            api.Terminate("");
        } else {
            api.LMSFinish("");
        }

        console.log("SCORM session finished");
        window.removeEventListener("beforeunload", finish);
        window.removeEventListener("pagehide", finish);
    }

    return {
        init,
        setCompletionStatus,
        setSuccessStatus,
        setScore,
        commit,
        finish,
    };
})();

export default ScormWrapper;